var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg16",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path816",
    d: "m28.830078 5.2226562a1.50015 1.50015 0 0 0 -.11328124.0097656c-13.516009 1.6562371-23.700039 13.148528-23.716797 26.765625a1.50015 1.50015 0 0 0 0 .00195312c0 14.893921 12.106079 27 27 27a1.50015 1.50015 0 0 0 .001953 0c13.622414-.01180228 25.120589-10.199168 26.775391-23.720703a1.50015 1.50015 0 0 0 -2.3164062-1.4335938c-3.1031886 2.052778-6.7402594 3.1500791-10.460938 3.1542969-10.511177 0-19-8.4888228-19-19 .0049146-3.7172244 1.1005876-7.3521086 3.1503906-10.453125a1.50015 1.50015 0 0 0 -1.3203125-2.3242188zm-2.5546875 3.5976562c-1.34796 2.8912692-2.2714692 5.9619028-2.2753906 9.1777344a1.50015 1.50015 0 0 0 0 .00195312c0 12.132498 9.8675025 22 22 22a1.50015 1.50015 0 0 0 .001953 0c3.2191299-.003319 6.2936436-.92729248 9.1875-2.2773438-2.605074 10.591259-12.034872 18.266776-23.189453 18.277344-13.271938 0-23.998929-10.726363-24-23.998047v-.00195312c.01462536-11.150429 7.6880418-20.574659 18.275391-23.179688z",
    "font-feature-settings": "normal",
    "font-variant-alternates": "normal",
    "font-variant-caps": "normal",
    "font-variant-ligatures": "normal",
    "font-variant-numeric": "normal",
    "font-variant-position": "normal",
    isolation: "auto",
    "mix-blend-mode": "normal",
    paintOrder: "fill markers stroke",
    "shape-padding": 0,
    "solid-color": "rgb(0,0,0)",
    "text-decoration-color": "rgb(0,0,0)",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-indent": 0,
    "text-orientation": "mixed",
    "text-transform": "none",
    "white-space": "normal"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/DarkMode.0428f25f.svg";
export { ForwardRef as ReactComponent };